import React, { useState, useEffect, useCallback } from "react";
import "./AddressConstraint.css";
import LocationSearchInput from "./LocationSearchInput";
import logger from "../services/Logger";

function AddressConstraint(props) {
  logger.info("AddressConstraint", props);
  const isLoaded = true;
  const [id] = useState(props.id ? props.id : "");
  const [alias, setAlias] = useState(props.alias ? props.alias : "");
  const [locationAddress, setLocationAddress] = useState(props.locationAddress ? props.locationAddress : "");
  const [commuteTime, setcommuteTime] = useState(props.commuteTime ? props.commuteTime : 0);
  const [commuteTimeDiviation, setcommuteTimeDiviation] = useState(props.commuteTimeDiviation ? props.commuteTimeDiviation : 0);

  const getAddressConstraintData = useCallback(() => {
    console.log("getting the data for address constraint");
    return {
      alias: alias,
      locationAddress: locationAddress,
      commuteTime: commuteTime,
      commuteTimeDiviation: commuteTimeDiviation,
    };
  }, [alias, locationAddress, commuteTime, commuteTimeDiviation]);

  const handleOnDataChange = useCallback(() => {
    props.onDataChange(id, getAddressConstraintData());
  }, [id, getAddressConstraintData, props]);

  useEffect(() => {
    handleOnDataChange();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alias, locationAddress, commuteTime, commuteTimeDiviation]);

  const handleAliasChange = (event) => {
    setAlias(event.target.value);
    //props.onDataChange(props.id, getAddressConstraintData());
  };

  const handleLocationAddressChange = (event) => {
    logger.info("handleLocationAddressChange", event);
    setLocationAddress(event);
    //props.onDataChange(props.id, getAddressConstraintData());
  };

  const handleCommuteTimeChange = (event) => {
    setcommuteTime(event.target.value);
    //props.onDataChange(props.id, getAddressConstraintData());
  };

  const handleCommuteTimeDiviationChange = (event) => {
    setcommuteTimeDiviation(event.target.value);
    //props.onDataChange(props.id, getAddressConstraintData());
  };

  return !isLoaded ? (
    <></>
  ) : (
    <>
      <div>
        Alias:
        <input type="text" value={alias} onChange={handleAliasChange} />
        Address:
        <LocationSearchInput onSelect={handleLocationAddressChange} />
        {/* Address:
        <input type="text" value={locationAddress} onChange={handleLocationAddressChange} style={{ width: "300px" }} /> */}
        Max commute time:
        <input type="number" value={commuteTime} onChange={handleCommuteTimeChange} />
        % above max time to consider:
        <input type="number" value={commuteTimeDiviation} onChange={handleCommuteTimeDiviationChange} />
      </div>
    </>
  );
}

export default AddressConstraint;
